import { Pipe, PipeTransform } from "@angular/core";
import { CollaboratorRoleEnum } from "@models/collaborator";

@Pipe({
  name: "collaboratorRoleEnum",
  standalone: true,
})
export class CollaboratorRoleEnumPipe implements PipeTransform {
  transform(value: CollaboratorRoleEnum): string {
    switch (value) {
      case CollaboratorRoleEnum.DOORPERSON:
        return "Porteiro";
      case CollaboratorRoleEnum.MANAGER:
        return "Gerente";
      case CollaboratorRoleEnum.POINT_OF_SALE:
        return "PDV";
      case CollaboratorRoleEnum.SELLER:
        return "Vendedor";
      case CollaboratorRoleEnum.MARKETING:
        return "Marketing";
      case CollaboratorRoleEnum.OBSERVER:
        return "Observador";
      case CollaboratorRoleEnum.PDV_PORTARIA:
        return "PDV Evento";
      case CollaboratorRoleEnum.PDV_PORTARIA_COORDINATOR:
        return "Coordenador PDV Evento";
      default:
        return value;
    }
  }
}
